import { render, staticRenderFns } from "./privacysidebar.vue?vue&type=template&id=1a8b4a14&"
import script from "./privacysidebar.vue?vue&type=script&lang=js&"
export * from "./privacysidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports